import * as React from "react";
import Svg, { Path, G } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={94}
      height={94}
      viewBox="0 0 94 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M90.728 47c0 24.15-19.578 43.728-43.729 43.728-24.15 0-43.728-19.577-43.728-43.727 0-24.151 19.578-43.729 43.728-43.729 24.15 0 43.729 19.578 43.729 43.729z"
        fill="#F4A148"
      />
      <Path
        d="M90.366 41.35c-1.426-10.053-5.438-16.167-11.204-22.177h-5.983v.584h-5.46v1.927c-6.31-.073-13.583.195-14.896.395 0 0 .545 9.749-.73 11.801-.404.649-.887 1.298-1.434 2.109l-23.003-4.167-2.98 16.446 36.1 6.54 2.979-16.447-7.252-1.313c3.03-2.22 6.705-4.761 6.705-4.761h4.51V36.4h5.46v4.47l17.188.479zM64.303 64.33c-.64-.83-1.917-.399-2.86.226l-6.097 4.678-.013-.02a1.189 1.189 0 01-.1.107l-.099.076c-.813.408-8.214 1.82-9.096.505-1.158-1.722-1.225-2.7.278-4.162.877-.853 1.35-2.012 2.837-3.661 3.284-3.636 3.056-6.114 2.312-6.697-1.353-1.057-4.861 5.506-7.159 6.459-3.103 1.286-7.182 2.829-7.182 2.829l-2.58-.61.302-1.316-4.949-1.131.121-.53L3.8 53.712c1.024 7.959 6.07 16.606 10.778 22.629l10.943 4.406.927-4.05 4.949 1.132 1.1-4.811c5.048 1.314 12.715 3.275 13.306 3.22.798-.077 9.539-2.074 11.828-3.67l-.004-.006c.01-.005.02-.01.028-.017l5.458-4.988c1.069-1.004 2.021-2.155 1.19-3.229z"
        fill="#E69744"
      />
      <Path
        d="M72.587 38.577l17.406.486C88.4 30.54 84.336 22.89 78.57 16.88h-5.983v21.697z"
        fill="#44403E"
      />
      <Path
        d="M30.018 58.224l-26.35-5.45A43.496 43.496 0 0012.56 74.04l12.961 3.85 4.497-19.666z"
        fill="#F47747"
      />
      <Path
        d="M44.757 36.983c-.078.78.634 1.488 1.588 1.582.953.094 1.789-.46 1.866-1.24l1.225-12.376c.078-.78-.634-1.488-1.587-1.582-.955-.094-1.79.46-1.867 1.24l-1.225 12.376z"
        fill="#F6B968"
      />
      <Path
        d="M44.807 37.025l-.006-12.902c.04-.418 1.535-.91 1.913-1.134l-1.163 14.236c-.017.172-.225.81-.188.971-.378-.298-.6-.721-.556-1.171z"
        fill="#EEAA59"
      />
      <Path
        d="M41.49 38.933c-.045.782.694 1.462 1.65 1.518.957.055 1.771-.534 1.817-1.315l.8-12.6c.044-.781-.766-1.276-1.723-1.332-.957-.056-1.77.532-1.816 1.315l-.728 12.414z"
        fill="#F6B968"
      />
      <Path
        d="M41.494 38.88l.696-12.723c.041-.418.833-.418 1.212-.641l-1.39 14.034c-.017.172.001.34.037.502-.377-.298-.6-.722-.555-1.172z"
        fill="#EEAA59"
      />
      <Path
        d="M37.996 39.222c-.047.782.693 1.462 1.65 1.518.957.056 1.771-.533 1.816-1.315l.726-12.413c.047-.784-.692-1.463-1.65-1.52-.955-.055-1.769.534-1.815 1.316l-.727 12.414z"
        fill="#F6B968"
      />
      <G fill="#33302F">
        <Path d="M79.09 35.639a1.08 1.08 0 01.427-.243l.062-1.025a.383.383 0 11.764.044l-.061 1.024a1.104 1.104 0 11-1.192.2zM82.784 35.347l.06-1.027a.382.382 0 11.765.045l-.06 1.024a1.105 1.105 0 01.308 1.818 1.102 1.102 0 01-1.502-1.617c.128-.118.274-.196.43-.243zM86.096 35.283l.06-1.026a.382.382 0 11.764.045l-.06 1.023c.134.058.26.144.366.258a1.105 1.105 0 01-.06 1.56 1.103 1.103 0 01-1.5-1.619 1.09 1.09 0 01.43-.24z" />
      </G>
      <Path
        d="M83.78 35.764a1.09 1.09 0 11-1.596 1.484 1.09 1.09 0 011.596-1.484zM87.064 35.725a1.092 1.092 0 01-1.598 1.484 1.09 1.09 0 011.599-1.484zM80.523 35.807a1.09 1.09 0 11-1.6 1.485 1.09 1.09 0 011.6-1.485z"
        fill="#22201F"
      />
      <Path
        d="M49.698 19.463c-.968.342-12.32 6.463-12.635 8.1-.268 1.391-.166 10.034-.095 12.412.002.075 0 .298 0 .298 0 .944.866 1.707 1.936 1.707 1.068 0 1.934-.763 1.934-1.707v-9.93c.115-.325.221-.549.323-.635.66-.567 6.18-3.155 8.827-3.331l3.294-3.67-3.465-3.268a.713.713 0 00-.119.024z"
        fill="#FFCC90"
      />
      <Path
        d="M38.28 40.475s-.256.128-.592.131l-.002.001h-.004c-.335 0-.603-.122-.603-.122-.038-.804-.1-2.008.11-2.477.092-.209.233-.275.362-.269l.001-.001c0-.002.002 0 .002 0 .001 0 .003 0 .004-.002v.003c.128-.01.275.055.388.262.252.464.298 1.669.335 2.474z"
        fill="#FFE0BC"
      />
      <G fill="#FFE0BC">
        <Path d="M37.399 27.192a.134.134 0 00.04.18l.69.47c.059.04.138.026.175-.032a.134.134 0 00-.042-.18l-.687-.47a.123.123 0 00-.176.032zM37.121 27.634a.137.137 0 00.04.182l.689.47c.06.04.138.026.175-.033a.134.134 0 00-.041-.18l-.689-.471c-.06-.04-.139-.025-.174.032z" />
      </G>
      <Path
        d="M27.067 29.526l-2.98 16.448 36.1 6.54 2.98-16.446-36.1-6.541z"
        fill="#C1E4EA"
      />
      <Path
        d="M58.874 50.997l-33.033-5.984 2.53-13.966 33.033 5.985-2.53 13.965zm-31.55-7.012l30.523 5.53 2.076-11.456L29.4 32.526l-2.076 11.458z"
        fill="#2A7B6D"
      />
      <Path
        d="M35.335 39.519a2.144 2.144 0 11-4.22-.763 2.144 2.144 0 014.22.763zM56.134 43.29a2.145 2.145 0 11-4.22-.766 2.145 2.145 0 014.22.765zM48.548 41.913a5.005 5.005 0 11-9.85-1.784 5.005 5.005 0 019.85 1.784z"
        fill="#2A7B6D"
      />
      <Path
        d="M49.818 19.44l.17 6.938c.55-.036.977.028 1.209.238 1.773 1.605 1.58 2.919.303 4.971-.744 1.198-1.753 2.38-2.96 4.635-2.663 4.98-.852 5.17.077 5.76 1.669 1.062 4.451-5.127 6.754-6.83 3.114-2.302 7.247-5.159 7.247-5.159h9.97v-10.53c0 .001-20.802-.323-22.77-.024z"
        fill="#FFCC90"
      />
      <Path
        d="M49.82 41.02s-.495-.221-1.03-.63l-.004-.004c0-.002-.003-.002-.004-.004-.533-.41-.876-.83-.876-.83.49-.64 1.21-1.607 1.863-1.695.29-.04.56.085.76.247h.002c.002 0 .002.001.003.003l.006.003v.001c.208.151.398.38.435.67.084.653-.665 1.6-1.155 2.24z"
        fill="#FFE0BC"
      />
      <G fill="#FFE0BC">
        <Path d="M51.71 34.17c-.037.058.03.168.152.248l1.406.91c.121.078.251.094.288.037.039-.058-.03-.17-.153-.248L52 34.207c-.122-.08-.252-.097-.29-.038zM51.427 34.608c-.038.06.03.17.15.249l1.406.91c.122.078.252.096.29.038.037-.06-.031-.17-.153-.25l-1.405-.91c-.122-.078-.252-.095-.288-.037z" />
      </G>
      <Path d="M72.586 17.463h-5.46v16.644h5.46V17.463z" fill="#F2EBEC" />
      <G fill="#F6B968">
        <Path d="M52.97 66.252a1.44 1.44 0 11-2.462-1.494l2.838-4.678a1.44 1.44 0 012.462 1.493l-2.838 4.679z" />
        <Path d="M47.075 69.117c-.733.31-3.431.739-3.74.005l-.638-.68c-.31-.73-1.312-3.101-.658-2.648 3.324 2.306 8.954-1.46 8.954-1.46a1.439 1.439 0 111.12 2.652l-5.038 2.13z" />
      </G>
      <Path
        d="M48.68 67.838l4.742-2.622c.163-.089.298-.205.407-.338.148-.125.27-.277.356-.46l1.666-4.221c.115-.239-2.354 3.84-2.354 3.84l-7.299 4.49c.914-.094 2.06-.456 2.483-.689z"
        fill="#EEAA59"
      />
      <G fill="#F6B968">
        <Path d="M56.512 65.704a1.44 1.44 0 11-2.622-1.193l2.264-4.981a1.44 1.44 0 012.623 1.192l-2.265 4.982z" />
        <Path d="M50.997 69.245c-.691.395-3.319 1.14-3.713.45l-.714-.6c-.393-.691.298-.872.989-1.267l6.763-3.796a1.44 1.44 0 111.428 2.501l-4.753 2.712z" />
      </G>
      <Path
        d="M51.038 67.99l4.742-2.62a1.42 1.42 0 00.407-.338c.146-.125.269-.28.356-.462l2.276-4.782c.114-.237.146-.488.118-.731l-3.083 5.132-7.3 4.49c.915-.093 2.061-.455 2.484-.688z"
        fill="#EEAA59"
      />
      <G fill="#F6B968">
        <Path d="M59.003 65.732a1.441 1.441 0 01-2.623-1.192l2.265-4.981a1.44 1.44 0 012.622 1.191l-2.264 4.982z" />
        <Path d="M53.49 69.273c-.692.395-3.319 1.14-3.714.45l-.714-.601c-.393-.69.3-.873.99-1.265l6.762-3.797a1.437 1.437 0 011.963.537c.396.69.154 1.57-.535 1.964l-4.752 2.712z" />
      </G>
      <Path
        d="M57.654 69.687c-.757.625-1.972.401-2.715-.499-.74-.9-.563-2.026.194-2.65l6.31-4.841c.942-.626 2.219-1.058 2.859-.227.83 1.073-.121 2.224-1.19 3.229l-5.458 4.988z"
        fill="#FFCC90"
      />
      <G>
        <Path
          d="M55.135 66.539c-.814.408-8.214 1.82-9.096.504-1.159-1.721-.721-2.787.782-4.248.877-.854 1.975-1.637 3.463-3.286 3.283-3.635 1.883-4.284 1.14-4.866-1.353-1.057-4.82 3.387-7.117 4.34-3.104 1.285-7.183 2.829-7.183 2.829l-7.106-1.677-1.918 8.872s16.817 4.457 17.703 4.373c.798-.076 9.539-2.072 11.828-3.669l-2.298-3.356a.708.708 0 01-.198.184z"
          fill="#FFCC90"
        />
      </G>
      <Path
        d="M29.897 58.758l-3.451 15.085 4.948 1.132 3.451-15.085-4.948-1.132z"
        fill="#F2EBEC"
      />
      <G>
        <G fill="#A83A48">
          <Path d="M22.836 73.672a1.023 1.023 0 00-.316-.332l.224-.929a.356.356 0 10-.692-.167l-.224.925a1.025 1.025 0 101.008.502zM19.63 72.408l.225-.93a.357.357 0 00-.693-.166l-.223.926a1.026 1.026 0 00-.767 1.533 1.026 1.026 0 001.773-1.03 1.03 1.03 0 00-.315-.333zM16.7 71.453l.225-.928a.355.355 0 10-.691-.168l-.225.926c-.136.015-.27.057-.396.13a1.027 1.027 0 001.03 1.775c.492-.286.657-.913.372-1.403a.99.99 0 00-.315-.332z" />
        </G>
        <Path
          d="M18.629 72.511a1.014 1.014 0 101.019 1.753 1.014 1.014 0 00-1.02-1.753zM15.72 71.585a1.015 1.015 0 101.02 1.754 1.015 1.015 0 00-1.02-1.754zM21.512 73.43a1.014 1.014 0 001.019 1.754 1.013 1.013 0 00-1.019-1.753z"
          fill="#702730"
        />
      </G>
      <Path
        d="M51.578 56.476s-.23-.35-.61-.71l-.002-.002-.004-.003c-.378-.357-.743-.566-.743-.566-.429.453-1.078 1.124-1.066 1.633.006.227.135.418.284.55 0 .003.001.003.002.005l.004.004.001-.002c.141.141.34.258.566.251.507-.017 1.14-.705 1.568-1.16zM64.16 63.278s-.12-.242-.358-.462c-.001 0-.002 0-.002-.003h-.003c-.24-.22-.495-.322-.495-.322-.432.45-1.086 1.118-1.17 1.53a.386.386 0 00.125.394l.001.003c.002 0 .002 0 .002.003v-.002a.408.408 0 00.413.096c.415-.106 1.055-.786 1.488-1.237z"
        fill="#FFE0BC"
      />
      <G fill="#FFE0BC">
        <Path d="M46.337 58.927c.049-.042.16.003.251.103l1.044 1.155c.09.1.124.217.077.26-.048.043-.16-.002-.25-.104l-1.044-1.154c-.091-.099-.125-.217-.078-.26zM46.699 58.603c.049-.044.161 0 .25.1l1.045 1.155c.09.1.124.217.077.26-.049.044-.161-.003-.252-.103l-1.043-1.156c-.09-.098-.125-.216-.077-.256z" />
      </G>
      <G fill="#FFE0BC">
        <Path d="M56.238 68.525c.055-.034.143.007.199.09l.633.972c.054.084.054.181 0 .215-.054.036-.143-.006-.198-.09l-.633-.971c-.055-.083-.054-.181 0-.216zM56.65 68.265c.055-.034.144.006.198.09l.633.97c.055.085.055.182 0 .216-.054.035-.143-.006-.198-.09l-.633-.971c-.055-.085-.055-.181 0-.215z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
